import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  ViewContainerRef,
  computed,
  output
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PriceContainerStore } from './price-container.store';
import { AddPaymentV2DialogComponent } from './add-payment-dialog/add-payment-dialog.component';
import { MatButton } from '@angular/material/button';
import { PriceContainerLineComponent } from './price-container-line/price-container-line.component';
import { NgIf, AsyncPipe } from '@angular/common';
import { map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIcon } from '@angular/material/icon';

export interface Chargeable {
  charge: number;
  tax_rate: number;
}

@Component({
  selector: 'app-price-container-v2',
  templateUrl: './price-container-v2.component.html',
  styleUrls: ['./price-container-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PriceContainerStore],
  standalone: true,
  imports: [NgIf, PriceContainerLineComponent, MatButton, AsyncPipe, MatIcon]
})
export class PriceContainerV2Component {
  @Input() set paymentableId(id: number) {
    this.store.selectPayments(id);
  }

  @Input() currency = null;
  @Input() canAddPayments = false;
  @Input() enableRounding = false;
  @Input() enableDiscount = false;
  @Input() set discount(discount: number) {
    this.store.setDiscount(discount);
  }

  @Input() set chargeableItems(items: Chargeable[]) {
    this.store.setCharges(items);
  }

  @Input() eposMode = false;

  @Output() paymentsChanged = this.store.pamyentsChanged;

  showRoundDialog = output<void>();
  editDiscount = output<void>();
  @Input() currencyRate = 1;

  @Input() set deliveryCharges(charges: Chargeable[]) {
    this.store.setDeliveryCharges(charges);
  }

  vm$ = this.store.vm$;
  private total = toSignal(this.vm$.pipe(map(({ total }) => total)));
  private totalExDiscount = toSignal(
    this.vm$.pipe(map(({ total, discount }) => total + discount))
  );
  shouldShowRoundTotalButton = computed(
    () =>
      this.enableRounding &&
      (Math.round(this.total() * this.currencyRate) / 100) % 1 !== 0
  );

  constructor(
    public dialog: MatDialog,
    private store: PriceContainerStore,
    public viewContainerRef: ViewContainerRef
  ) {}

  viewAddPaymentDialog() {
    this.dialog.open(AddPaymentV2DialogComponent, {
      viewContainerRef: this.viewContainerRef,
      minWidth: '50vw',
      data: {
        currency: this.currency,
        currencyRate: this.currencyRate
      }
    });
  }

  getTotalAmount() {
    return this.total();
  }

  getTotalExDiscountAmount() {
    return this.totalExDiscount();
  }
}
